import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getCMS } from "../../requests";
import { deleteAuthToken, notifyError } from "../../utils/helper";
import { formatDateLong } from "../helper/formatters";

const CMSUI = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const getCMSData = async () => {
    dispatch(startLoader());
    try {
      const response = await getCMS({ type: 1 });
      console.log(response.data.data);
      setData(response.data.data);
    } catch (error) {
      console.log(error);
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }
  };

  useEffect(() => {
    getCMSData();
  }, []);

  //     const [data, setData] = useState([{
  //         title: "About Us",
  //         last_updated_by: "Admin",
  //         last_updated_on: "2021-01-01",
  //         actions: "Edit",
  //         actions_draft: "Edit Draft",

  //     },
  //     {
  //         title:'Terms and Conditions',
  //         last_updated_by: "Admin",
  //         last_updated_on: "2021-01-01",
  //         actions: "Edit",
  //         actions_draft: "Edit Draft",

  //     },
  //     {
  //         title:'Privacy Policy',
  //         last_updated_by: "Admin",
  //         last_updated_on: "2021-01-01",
  //         actions: "Edit",
  //         actions_draft: "Edit Draft",

  //     }
  // ]);
  return (
    <div className="tm-main">
      <div className="overview-head">
        <div className="overview-head-left">Content Management</div>
      </div>
      <div className="teacher-table" style={{ borderTop: "none" }}>
        <div className="teacher-table-head">
          <div className="teacher-table-head-cell" style={{ width: "30%" }}>
            Title
          </div>

          <div className="teacher-table-head-cell" style={{ width: "20%" }}>
            Last Updated by
          </div>
          <div className="teacher-table-head-cell" style={{ width: "20%" }}>
            Last Updated on
          </div>
          <div className="teacher-table-head-cell" style={{ width: "30%" }}>
            Actions
          </div>
        </div>

        {data.length > 0 &&
          data.map((el, i) => (
            <div
              key={i}
              className="teacher-table-row"
              style={{ borderBottom: i == data.length - 1 && "none" }}
            >
              <div className="teacher-table-row-cell" style={{ width: "30%" }}>
                {el.slug}
              </div>

              <div className="teacher-table-row-cell" style={{ width: "20%" }}>
                {el.email}
              </div>
              <div className="teacher-table-row-cell" style={{ width: "20%" }}>
                {formatDateLong(el.updated_at)}
              </div>
              <div
                className="teacher-table-row-cell pe-cursor"
                style={{ width: "30%", display:'flex', gap:'10px' }}
               
              >
                <button
                  className="my-btn"
                
                  onClick={() => navigate(`/cms/${el.slug}`)}
                >
                  Edit
                </button>
                <button
                  className="my-btn"
                  style={{ backgroundColor: "#E0F5FE", color: "#01A7DE" }}
                  onClick={() => navigate(`/cms/draft/${el.slug}`)}
                >
                  Edit Draft
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CMSUI;
